import { PropsWithChildren } from 'react';

interface StatMiniCardProps {
  label: string;
  icon: React.ReactNode;
  iconBgColor: string;
}
export const StatMiniCard: React.FC<PropsWithChildren<StatMiniCardProps>> = ({
  label,
  icon,
  iconBgColor,
  children,
}) => {
  return (
    <div className="flex items-center gap-4 flex-[1_0_0] border  border-[color:var(--200-line-,#E5E5E5)]  p-[15px] rounded-xl border-solid">
      <div className="size-12  rounded-full flex items-center justify-center" style={{ background: iconBgColor }}>
        {icon}
      </div>
      <div className="flex flex-col space-y-1">
        <div className="self-stretch text-[color:var(--800-fill-,#262626)] [font-family:Geist] text-xl font-semibold leading-[120%] tracking-[-0.48px]">
          {children}
        </div>
        <div className="self-stretch text-[color:var(--500-fill--,#737373)] [font-family:Geist] text-base font-normal leading-[150%]">
          {label}
        </div>
      </div>
    </div>
  );
};
